import { FC, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSuccessfulUpdateSnackbar, useFailedUpdateSnackbar, LoadingIndicator, ApiError } from "../../../../Components/CoreLib/library";
import { HourlyLineItemForm } from "../../../../Components/Forms/QuoteForm";
import { HourlyLineItemDto } from "../../../../dtos";
import { useLazyGetQuoteByIdQuery, useGetHourlyLineItemByIdQuery, useUpdateHourlyLineItemMutation } from "../../../../store/generated/generatedApi";


export const EditHourlyLineItemView: FC = () => {
    const { quoteId, lineItemId } = useParams();
    const navigate = useNavigate();
    const [getQuote, { data: quote, isLoading: isQuoteLoading }] = useLazyGetQuoteByIdQuery();
    const { data, isLoading, error, refetch } = useGetHourlyLineItemByIdQuery({ id: lineItemId! });
    const [updateHourlyLineItem, { isSuccess, isError, reset }] = useUpdateHourlyLineItemMutation();

    useEffect(() => {
        if (quoteId && !quote) {
            getQuote({ id: quoteId! });
        }
    }, [quote, quoteId, getQuote]);

    useSuccessfulUpdateSnackbar('Hourly Line Item', isSuccess, () => {
        if (quoteId) {
            navigate(`/quote/${quoteId}/lineItems`);
        } else {
            navigate(`/quotes`);
        }
    });
    useFailedUpdateSnackbar('Hourly Line Item', isError, reset);

    const handleSave = (values: HourlyLineItemDto) => {
        updateHourlyLineItem(values);
    };

    const handleCancel = () => {
        if (quoteId) {
            navigate(`/quote/${quoteId}/lineItems`)
        } else {
            navigate(`/quotes`);
        }
    };

    if (isLoading || isQuoteLoading) {
        return <LoadingIndicator />;
    }

    if (error) {
        return <ApiError onReloadClick={refetch} />;
    }

    return <HourlyLineItemForm save={handleSave} cancel={handleCancel} initValues={data} quote={quote} />;
};
